import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Table, Button, Form } from "react-bootstrap";
import Sidebar from "../../components/Sidebar";
import Breadcrumbs from "./Breadcrumbs";
import { useParams } from "react-router-dom";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { isEmpty, startCase } from "lodash";
import ReactPaginate from "react-paginate";
import helpers from "../../utils/helpers";
import AuthContext from "../../context/AuthContext";
import Pagination from "../../components/Pagination";
import { FilterBar } from "../../components/FilterBar";
import moment from "moment";
import DatePicker from "react-datepicker";

const TransactionHistory = () => {
  const params = useParams();
  let { user, setAccountError } = useContext(AuthContext);
  const [getLogData, setLogData] = useState("");
  const [pageCount, setPageCount] = useState(0);
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [search_params, setSearchParams] = useState({
    page: 1,
    limit: 100,
    toPeriod: currentDate,
    fromPeriod: previousDate,
  });
  const myStatementData = async () => {
    search_params.user_id = params?.id;
    const { status, data: response_users } = await apiGet(
      apiPath.usertransactionTxnLogs,
      search_params
    );
    if (status === 200) {
      if (response_users.success) {
        setLogData(response_users.results);
        if (response_users.results.data?.length == 0) {
          setAccountError(true);
        } else {
          setAccountError(false);
        }
      }
    }
  };

  const handlePageClick = (event) => {
    setSearchParams((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
  };

  useEffect(() => {
    setPageCount(getLogData?.totalPages || []);
  }, [getLogData]);

  // useEffect(() => {
  //   myStatementData();
  // }, [search_params]);
  useEffect(() => {
    myStatementData();
  }, [search_params?.filterByDay]);
  return (
    <div className="top-header-inner">
      <section className="py-4 main-inner-outer">
        <Container fluid>
          <Breadcrumbs user_id={params?.id} />
          <div className="accout_cols_outer">
            <div className="left_side">
              <Sidebar />
            </div>

            <div className="right_side">
              <div className="inner-wrapper">
                <h2 className="common-heading">Transaction History</h2>

                <section className="account-table">
                  <div className="inner-wrapper">
                    <Form className="bet_status bettinghistory">
                      <div className="d-flex align-items-center">
                        <div
                          className="bet-sec bet-period bettinghistory-tab"
                          style={{ marginRight: "6px" }}
                        >
                          <Form.Label
                            className="mb-0"
                            style={{ marginBottom: "7px" }}
                          >
                            Period
                          </Form.Label>
                          <Form.Group className="form-group">
                            <DatePicker
                              className="small_form_control"
                              selected={
                                search_params.fromPeriod
                                  ? new Date(search_params.fromPeriod)
                                  : null
                              }
                              onChange={(date) =>
                                setSearchParams({
                                  ...search_params,
                                  fromPeriod: date.toISOString().split("T")[0],
                                  filterByDay: "",
                                })
                              }
                              dateFormat="yyyy-MM-dd"
                              maxDate={new Date()}
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                              placeholderText="Select a date"
                              onFocus={(e) => e.target.blur()}
                            />
                            <Form.Control
                              style={{ marginLeft: "4px" }}
                              className="small_form_control"
                              type="text"
                              placeholder="09:00"
                              disabled
                            />
                          </Form.Group>
                        </div>

                        <div className="bet-sec bet-period">
                          <Form.Label
                            style={{ marginRight: "2px", marginBottom: `0px` }}
                            className="mb-0"
                          >
                            to
                          </Form.Label>
                          <Form.Group className="form-group">
                            <DatePicker
                              className="small_form_control"
                              selected={
                                search_params.toPeriod
                                  ? new Date(search_params.toPeriod)
                                  : null
                              }
                              onChange={(date) =>
                                setSearchParams({
                                  ...search_params,
                                  toPeriod: date.toISOString().split("T")[0],
                                  filterByDay: "",
                                })
                              }
                              dateFormat="yyyy-MM-dd"
                              minDate={
                                search_params?.fromPeriod
                                  ? new Date(search_params?.fromPeriod)
                                      .toISOString()
                                      .split("T")[0]
                                  : new Date()
                              }
                              maxDate={new Date().toISOString().split("T")[0]}
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                              placeholderText="Select a date"
                              onFocus={(e) => e.target.blur()}
                            />
                            <Form.Control
                              style={{ marginLeft: "4px", width: "47px" }}
                              className="small_form_control"
                              type="text"
                              placeholder="08:59"
                              disabled
                            />
                          </Form.Group>
                        </div>
                      </div>
                      <div className="history-btn mt-2">
                        <ul className="list-unstyled mb-0">
                          <li>
                            <Button
                              className={"me-0 theme_light_btn"}
                              onClick={(e) =>
                                setSearchParams({
                                  ...search_params,
                                  filterByDay: "today",
                                })
                              }
                              style={{ padding: `0 10px`, lineHeight: `25px` }}
                            >
                              Just For Today
                            </Button>
                          </li>
                          <li>
                            <Button
                              className={"me-0 theme_light_btn"}
                              onClick={(e) =>
                                setSearchParams({
                                  ...search_params,
                                  filterByDay: "yesterday",
                                })
                              }
                              style={{ padding: `0 10px`, lineHeight: `25px` }}
                            >
                              From Yesterday
                            </Button>
                          </li>
                          <li>
                            <Button
                              className="theme_dark_btn"
                              onClick={() => myStatementData("search")}
                            >
                              Get History
                            </Button>
                          </li>
                        </ul>
                      </div>
                    </Form>
                  </div>
                  <div className="responsive transaction-history">
                    <div id="noReportMessage">
                      <p className="p-0" style={{ marginBottom: "7px" }}>
                        Banking log reserves 62 days data. Search time period is
                        date between 14 days, ex: 1/1~1/14, 1/15~28.
                      </p>
                      <Button className="theme_dark_btn themebtndownload">
                        Download
                      </Button>
                    </div>
                    <Table>
                      <thead>
                        <tr>
                          <th scope="col">Date/Time</th>
                          <th scope="col" style={{ textAlign: "right" }}>
                            Deposit
                          </th>
                          <th scope="col" style={{ textAlign: "right" }}>
                            Withdraw{" "}
                          </th>
                          <th scope="col" style={{ textAlign: "right" }}>
                            Balance
                          </th>
                          <th scope="col" style={{ textAlign: "right" }}>
                            Remark
                          </th>
                          <th scope="col" style={{ textAlign: "right" }}>
                            From/To
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {getLogData.data &&
                          getLogData.data.map((item, key) => {
                            return (
                              <tr>
                                <td>
                                  {moment(item?.createdAt).format(
                                    "YYYY-MM-DD hh:mm:ss"
                                  )}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {item?.transactionType === "credit" ? (
                                    <span className="">
                                      {helpers.currencyFormat(item?.amount)}
                                    </span>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {" "}
                                  {item?.transactionType === "debit" ? (
                                    <span className="text-danger">
                                      {"(" +
                                        helpers.currencyFormat(item?.amount) +
                                        ")"}
                                    </span>
                                  ) : (
                                    "-"
                                  )}
                                </td>

                                <td style={{ textAlign: "right" }}>
                                  {item?.newBalance > 0
                                    ? helpers.currencyFormat(item?.newBalance)
                                    : "0.00"}
                                </td>
                                <td width={"26%"}>{item?.remark || ""}</td>

                                <td style={{ textAlign: "right" }}>
                                  {startCase(item?.createdByData?.userType)}{" "}
                                  <img
                                    class="fromto"
                                    src={require("../../assets/images/transparent.gif")}
                                  />
                                  {item?.userData?.username}
                                </td>
                              </tr>
                            );
                          })}
                        {isEmpty(getLogData.data) ? (
                          <tr>
                            <td colSpan={9}>No records found</td>
                          </tr>
                        ) : null}
                      </tbody>
                    </Table>
                    {getLogData?.data?.length > 0 && (
                      <Pagination
                        handlePageClick={handlePageClick}
                        pageCount={pageCount}
                        viewpage={0}
                      />
                    )}
                  </div>
                </section>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default TransactionHistory;
